
export interface FooterLink {
    label: string,
    url: string
}

export const HOME_PAGE_FOOTER_LINKS: string[] = [
    "guida",
    "diversamente abili",
    "sitemap",
    "servizi",
    "elearning",
    "cookie",
    "statistiche",
    "antiphishing",
    "logo",
    "merchandising",
    "magazine",
    "contatti",
    "5x1000",
    "crediti",
    "feedback",
    "dove siamo",
    "campus",
    "accommodation"
];

export const SUBPAGE_FOOTER_ADDITIONAL_LINKS: string[] = [
    "aree riservate",
    "ufficio stampa",
    "sostieni il merito"
];